import {
  FETCH_DRIVER_TRIPS_REQUEST,
  FETCH_DRIVER_TRIPS_SUCCESS,
  FETCH_DRIVER_TRIPS_FAILURE,

  UPDATE_DRIVER_TRIP_REQUEST,
  UPDATE_DRIVER_TRIP_SUCCESS,
  UPDATE_DRIVER_TRIP_FAILURE,

  DELETE_DRIVER_TRIP_REQUEST,
  DELETE_DRIVER_TRIP_SUCCESS,
  DELETE_DRIVER_TRIP_FAILURE,
} from "../actions/types";

const initialState = {
  trips: [],

  total: 0,
  page: 1,
  size: 10,
  pages: 0,

  loading: false,
  error: null,
  message: "",
};

const driverTripReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {

    
    // FETCH
    

    case FETCH_DRIVER_TRIPS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_DRIVER_TRIPS_SUCCESS:
      return {
        ...state,
        loading: false,

        trips:
          action.payload?.data || [],

        total:
          action.payload?.total || 0,

        page:
          action.payload?.page || 1,

        size:
          action.payload?.size || 10,

        pages:
          action.payload?.pages || 0,

        message:
          "Driver trips loaded successfully",
      };

    case FETCH_DRIVER_TRIPS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        trips: [],
      };

    
    // UPDATE
    

    case UPDATE_DRIVER_TRIP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case UPDATE_DRIVER_TRIP_SUCCESS:
      return {
        ...state,
        loading: false,

        trips: state.trips.map(
          (trip) =>
            trip.trip_id ===
            action.payload.trip_id
              ? action.payload
              : trip
        ),

        message:
          "Driver trip updated successfully",
      };

    case UPDATE_DRIVER_TRIP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    
    // DELETE / CANCEL
    

    case DELETE_DRIVER_TRIP_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case DELETE_DRIVER_TRIP_SUCCESS:
  return {
    ...state,
    loading: false,

    trips: state.trips.map(
      (trip) =>
        trip.trip_id === action.payload?.trip_id
          ? {
              ...trip,
              status: action.payload.status || "CANCELLED",
            }
          : trip
    ),


    total: state.total,

    message:
      "Driver trip cancelled successfully",
  };

    case DELETE_DRIVER_TRIP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default driverTripReducer;